module.exports = __webpack_public_path__ + "media/images/icons8-info-red-f1890cfe926ca82b6c2112ce6c2ebf2f.svg";